import { Component, Input, OnInit } from '@angular/core';
import { ViewMode } from '../../../../models';

@Component({
  selector: 'shipping-rates-filter-example',
  templateUrl: './shipping-rates-filter-example.component.html',
  styleUrls: ['./shipping-rates-filter-example.component.scss'],
  standalone: false,
})
export class ShippingRatesFilterExampleComponent implements OnInit {
  @Input() template;
  @Input() mode: ViewMode;
  @Input() isMobile: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
